/**
 * Derived run-up (TDD §3.1, R3). `runwayBefore` is NEVER authored — an inflated value
 * would let the fence/bunch/reversal checks false-pass. It is the length of the contiguous
 * immediately-preceding WALKABLE run (`platform` or `conveyor` — smooth floor the runner
 * builds speed on), pinned to 0 for the first segment and 0 right after any non-walkable
 * segment (gap/fence/reversal/collapse break the run-up).
 */
import type { SpatialLevel } from './schema.js';
import { WALKABLE_SEGMENT_KINDS } from './schema.js';

const WALKABLE = new Set<string>(WALKABLE_SEGMENT_KINDS);

export function deriveRunways(level: SpatialLevel): number[] {
  const segments = level.segments ?? [];
  const runways: number[] = new Array(segments.length);
  let acc = 0;
  for (let i = 0; i < segments.length; i++) {
    runways[i] = acc; // run-up available BEFORE segment i
    if (WALKABLE.has(segments[i].kind)) {
      acc += segments[i].span;
    } else {
      acc = 0; // non-walkable: no ground to run up on after it
    }
  }
  return runways;
}
